import { useAuth0 } from "@auth0/auth0-react";
import { Button } from 'antd'

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  return <Button size="large" type='primary' onClick={() => loginWithRedirect({
    // Come back to the same URL (e.g. an `adapt` deep link) after logging in
    appState: { returnTo: window.location.pathname + window.location.search },
  })}>Log In</Button>;
};

export default LoginButton;